var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-product" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isEdit
              ? _vm.$t("payment_links.edit_product")
              : _vm.$t("payment_links.add_new_product"),
            visible: _vm.dialogVisible,
            width: "660px",
            "close-on-click-modal": false,
            "before-close": _vm.clickCancel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(" " + _vm._s(_vm.$t("payment_links.product_info")) + " "),
          ]),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                "label-width": "200px",
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "left",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "name",
                    label: _vm.$t("payment_links.product_name"),
                    required: "",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "from-input",
                    attrs: {
                      maxlength: "128",
                      placeholder: _vm.$t("payment_links.product_name"),
                      size: "small",
                      type: "text",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "price",
                    label: _vm.$t("payment_links.price"),
                    required: "",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "from-input",
                    attrs: {
                      placeholder: _vm.$t("payment_links.price"),
                      size: "small",
                      type: "text",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.price,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "price",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.price",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { prop: "pic", label: _vm.$t("payment_links.image") },
                },
                [
                  _c(
                    "el-upload",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.uploadLoading,
                          expression: "uploadLoading",
                        },
                      ],
                      class: {
                        hideUploadFlag: _vm.isHideUpdate,
                        "upload-image": true,
                      },
                      attrs: {
                        action: "#",
                        "list-type": "picture-card",
                        "auto-upload": false,
                        "file-list": _vm.fileList,
                        limit: 1,
                        "on-change": _vm.handleImageChange,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "file",
                          fn: function (ref) {
                            var file = ref.file
                            return _c("div", {}, [
                              _c("img", {
                                staticClass: "el-upload-list__item-thumbnail",
                                attrs: { src: file.url, alt: "" },
                              }),
                              _c(
                                "span",
                                { staticClass: "el-upload-list__item-actions" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-upload-list__item-preview",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlePictureCardPreview(
                                            file
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-zoom-in",
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-upload-list__item-delete",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleRemove(file)
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-delete" })]
                                  ),
                                ]
                              ),
                            ])
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isHideUpdate,
                              expression: "!isHideUpdate",
                            },
                          ],
                          attrs: { slot: "default" },
                          slot: "default",
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { type: "primary", size: "small" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("components.click_to_upload")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c("el-button", { on: { click: _vm.clickCancel } }, [
                _vm._v(_vm._s(_vm.$t("components.cancel"))),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info", disabled: _vm.submitLoading },
                  on: { click: _vm.clickSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogImageVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogImageVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }